export default "__VITE_ASSET__573383c8__"